import { Box } from "@circleco/compass/components/Box";
import { LoadingRegion } from "@circleco/compass/components/LoadingRegion";
import { Skeleton } from "@circleco/compass/components/Skeleton";

import { t } from "@/i18n-js/instance";

const ImagePostSeoSettingsSkeleton = () => (
  <Box>
    <div className="flex flex-col gap-5">
      <Skeleton shape="pill" className="h-4 w-10" />
      <Skeleton shape="pill" className="h-4 w-24" />
      <Skeleton shape="rounded" className="h-10 w-full" />
      <Skeleton shape="pill" className="h-4 w-20" />
      <Skeleton shape="rounded" className="h-10 w-full" />
      <Skeleton shape="pill" className="h-4 w-28" />
      <Skeleton shape="rounded" className="h-24 w-full" />
    </div>
  </Box>
);

const ImagePostSocialSettingsSkeleton = () => (
  <Box>
    <div className="flex flex-col gap-5">
      <Skeleton shape="pill" className="h-4 w-12" />
      <Skeleton shape="rounded" className="h-24 w-full" />
      <Skeleton shape="pill" className="h-4 w-24" />
      <Skeleton shape="rounded" className="h-10 w-full" />
      <Skeleton shape="pill" className="h-4 w-32" />
      <Skeleton shape="rounded" className="h-24 w-full" />
    </div>
  </Box>
);

export const ImagePostSeoSectionSkeleton = () => (
  <LoadingRegion label={t("loading_ellipsis")}>
    <div className="flex flex-col gap-3">
      <ImagePostSeoSettingsSkeleton />
      <ImagePostSocialSettingsSkeleton />
    </div>
  </LoadingRegion>
);
